import styled from "styled-components";

// Base table container with consistent styling
export const TableContainer = styled.div`
    overflow-x: auto;
    margin-top: 0.5em;
    border: 1px solid #ddd;
    border-radius: 8px;
    background-color: white;
    width: 100%;
    max-width: 100%;
    min-width: 0;
    box-sizing: border-box;
`;

// Grid-based table layout
export const TableGrid = styled.div<{ $columns: number }>`
    display: grid;
    min-width: 800px;
    grid-template-columns: ${props => `repeat(${props.$columns}, 1fr)`};
`;

// Header row container
export const TableHeader = styled.div`
    display: contents;
`;

// Header cell with consistent styling
export const TableHeaderCell = styled.div`
    background-color: #f8f9fa;
    padding: 0.125em 0.5em;
    border-bottom: 1px solid #ddd;
    border-right: 1px solid #ddd;
    font-weight: 600;
    text-align: center;
    font-size: 0.85em;
    color: #333;
    
    &:first-child {
        border-left: 1px solid #ddd;
        text-align: left;
        min-width: 200px;
    }
`;

// Table row container
export const TableRow = styled.div`
    display: contents;
`;

// Table cell with consistent styling
export const TableCell = styled.div`
    padding: 0.125em 0.5em;
    border-bottom: 1px solid #e9ecef;
    border-right: 1px solid #e9ecef;
    font-size: 0.85em;
    display: flex;
    align-items: center;
    justify-content: center;
    
    &:first-child {
        border-left: 1px solid #e9ecef;
        text-align: left;
        justify-content: flex-start;
        font-weight: 500;
        background-color: #f8f9fa;
    }
`;

// Empty cell styling
export const EmptyCell = styled.div`
    color: #6c757d;
    font-style: italic;
    font-size: 0.75em;
`;

// Value display with consistent styling
export const ValueDisplay = styled.span`
    font-weight: 600;
    font-size: 0.9em;
    color: #333;
`;

// Change indicator with color coding
export const ChangeIndicator = styled.span<{ $isPositive?: boolean; $isNegative?: boolean }>`
    font-size: 0.75em;
    font-weight: 500;
    color: ${props => {
        if (props.$isPositive) return '#28a745';
        if (props.$isNegative) return '#dc3545';
        return '#6c757d';
    }};
`;

// Rank display with medal colors
export const RankDisplay = styled.div<{ $rank: number }>`
    font-weight: 600;
    font-size: 0.9em;
    color: ${props => {
        if (props.$rank === 1) return '#ffd700';
        if (props.$rank === 2) return '#c0c0c0';
        if (props.$rank === 3) return '#cd7f32';
        return '#333';
    }};
`; 